import { render, staticRenderFns } from "./P4PDashboard.vue?vue&type=template&id=d3cc323a&scoped=true&"
import script from "./P4PDashboard.vue?vue&type=script&lang=js&"
export * from "./P4PDashboard.vue?vue&type=script&lang=js&"
import style0 from "./P4PDashboard.vue?vue&type=style&index=0&id=d3cc323a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3cc323a",
  null
  
)

export default component.exports